<template>
  <div class="h-100">
    <!-- Main Navbar -->
    <main-navbar :stickyTop="false" />

    <d-container
      class="h-100 d-flex flex-column main-content justify-content-center"
    >
      <d-row class="login-form justify-content-center">
        <d-col cols="12" md="8" lg="7" xl="6">
          <alert :fixed="false" />
          <d-card class="p-4 mb-4 card-small">
            <!-- Content -->
            <router-view></router-view>
          </d-card>
        </d-col>
      </d-row>
    </d-container>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

import MainNavbar from '_common/layout/MainNavbar/MainNavbar.vue';
import Alert from '_shared/Alert.vue';

export default {
  name: 'login',
  components: {
    Alert,
    MainNavbar,
  },
  methods: {
    ...mapActions(['logout']),
  },
  mounted() {
    this.logout();
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';
.title {
  font-size: 18px;
  margin: 0 0 15px 0;
  justify-content: center;
  height: 70px;
  align-items: center;
  display: flex;
  img {
    max-height: 48px;
    max-width: 80%;
  }
}
</style>
